import {useCallback, useState} from 'react'
import {URL} from '../gql/client'
import {STORAGE_NAMES} from '../helpers/consts'

export const useUploadFile = <T,>(): [
  (body: FormData) => Promise<T>,
  {data: T | null; loading: boolean; error: null | string}
] => {
  const [data, setData] = useState<T | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<null | string>(null)

  const getFetch = useCallback(async (body: FormData) => {
    const token = window.localStorage.getItem(STORAGE_NAMES.TOKEN)
    if (!token) {
      const msg = 'Signature expired'
      setError(msg)
      throw new Error(msg)
    }
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${token}`)
    myHeaders.append(
      'Cookie',
      'csrftoken=le5GvRfK7iZkorIAyYzckwQ7m3ux3RztbFZqjr3Rvv4KAcVBn52gQGazZPqaWm5u'
    )
    const requestOptions: RequestInit = {
      method: 'POST',
      headers: myHeaders,
      body,
      redirect: 'follow',
    }
    setLoading(true)
    setError(null)
    try {
      const response = await fetch(`${URL}/api`, requestOptions)
      if (!response.ok) throw new Error('Something happened')

      const result = await response.json()
      setData(result.data)

      if (result?.data?.errors?.length > 0) {
        throw new Error(result.data.errors[0]?.message || 'Algo ocurrio')
      }
      if (result?.errors?.length > 0) {
        throw new Error(result.errors[0]?.message || 'Algo ocurrio')
      }

      return result.data as T
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err)
      setError(message)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  return [getFetch, {data, loading, error}]
}
